export class BalanceSheet {
    ID: string;
    ASSET_AR: number;
    ASSET_CASH: number;
    ASSET_INVENTORY: number;
    ASSET_FIXED_COST: number;
    ASSET_FIXED_APPRAISED: boolean = false;
    ASSET_OTHER: number;
    ASSET_OTHER_LABEL: string;
    ASSET_REAL_ESTATE: number;
    LIABILITY_AP: number;
    LIABILITY_SHORT_TERM_NOTES: number;
    LIABILITY_LONG_TERM: number;
    LIABILITY_OTHER: number;
    LIABILITY_OTHER_LABEL: string;
    LIABILITY_AP_REF: number;
    LIABILITY_SHORT_TERM_NOTES_REF: number;
    LIABILITY_LONG_TERM_REF: number;
    LIABILITY_OTHER_REF: number;
    ACQ_PRICE: number;
    ACQ_NONE: boolean = false;

    static parse(json: any): BalanceSheet {
        if (json) {
            const bs = new BalanceSheet();

            bs.ID = json.ID;
            bs.ASSET_AR = json.ASSET_AR;
            bs.ASSET_CASH = json.ASSET_CASH;
            bs.ASSET_INVENTORY = json.ASSET_INVENTORY;
            bs.ASSET_FIXED_COST = json.ASSET_FIXED_COST;
            bs.ASSET_FIXED_APPRAISED = json.ASSET_FIXED_APPRAISED;
            bs.ASSET_OTHER = json.ASSET_OTHER;
            bs.ASSET_OTHER_LABEL = json.ASSET_OTHER_LABEL;
            bs.ASSET_REAL_ESTATE = json.ASSET_REAL_ESTATE;
            bs.LIABILITY_AP = json.LIABILITY_AP;
            bs.LIABILITY_SHORT_TERM_NOTES = json.LIABILITY_SHORT_TERM_NOTES;
            bs.LIABILITY_LONG_TERM = json.LIABILITY_LONG_TERM;
            bs.LIABILITY_OTHER = json.LIABILITY_OTHER;
            bs.LIABILITY_OTHER_LABEL = json.LIABILITY_OTHER_LABEL;
            bs.LIABILITY_AP_REF = json.LIABILITY_AP_REF;
            bs.LIABILITY_SHORT_TERM_NOTES_REF = json.LIABILITY_SHORT_TERM_NOTES_REF;
            bs.LIABILITY_LONG_TERM_REF = json.LIABILITY_LONG_TERM_REF;
            bs.LIABILITY_OTHER_REF = json.LIABILITY_OTHER_REF;
            bs.ACQ_PRICE = json.ACQ_PRICE;
            bs.ACQ_NONE = json.ACQ_NONE;

            return bs;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<BalanceSheet> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(BalanceSheet.parse(j));

        return arr;
    }

}
